import Icon from "@ant-design/icons";

const ClubHouseSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M2393 5106 c-200 -38 -365 -128 -509 -277 -341 -353 -349 -910 -20
   -1275 69 -77 187 -168 262 -202 l51 -24 58 -216 59 -215 -44 -38 -44 -38 -911
   -3 -910 -3 -51 -27 c-29 -15 -65 -44 -82 -63 -16 -20 -78 -145 -138 -278 -104
   -232 -108 -245 -108 -312 -1 -103 50 -190 133 -226 l31 -14 2 -855 c3 -855 3
   -855 25 -895 25 -47 74 -95 123 -121 34 -18 109 -19 2240 -19 2131 0 2206 1
   2240 19 49 26 98 74 123 121 22 40 22 40 25 895 l2 855 31 14 c83 36 134 123
   133 226 0 67 -4 80 -109 313 -116 261 -145 305 -222 343 l-48 24 -910 3 -910
   3 -44 38 -45 38 58 215 58 216 51 23 c72 34 192 125 256 195 332 363 330 918
   -3 1272 -185 195 -391 289 -656 298 -81 2 -150 -1 -197 -10z m362 -182 c405
   -109 651 -526 549 -929 -57 -222 -201 -398 -413 -505 -197 -99 -465 -99 -662
   0 -139 70 -234 154 -312 277 -133 208 -160 442 -78 674 93 264 330 456 616
   503 55 8 239 -3 300 -20z m-250 -1679 c39 -4 108 -2 154 4 47 6 85 10 86 8 1
   -1 -12 -52 -29 -113 l-31 -111 -40 18 c-52 24 -119 23 -171 0 l-42 -19 -6 26
   c-3 15 -16 67 -30 115 l-25 89 32 -6 c18 -3 64 -8 102 -11z m636 -871 c310
   -290 565 -532 567 -538 1 -6 -20 -33 -47 -60 -46 -45 -52 -48 -70 -35 -10 8
   -236 217 -500 464 -264 248 -492 454 -506 459 -16 6 -34 6 -50 0 -14 -5 -247
   -217 -519 -471 -272 -255 -499 -463 -503 -463 -14 0 -106 97 -102 107 9 22
   1135 1063 1150 1063 9 0 270 -237 580 -526z m-1133 266 c-1 -5 -142 -140 -313
   -299 l-310 -290 -580 0 c-441 0 -584 3 -596 12 -21 16 -39 51 -39 74 1 10 47
   122 104 248 93 209 106 232 137 247 32 17 91 18 817 18 511 0 783 -3 780 -10z
   m2701 -8 c31 -15 44 -38 137 -247 57 -126 103 -238 104 -248 0 -23 -18 -58
   -39 -74 -12 -9 -155 -12 -596 -12 l-580 0 -310 290 c-170 159 -311 294 -313
   299 -2 6 288 10 780 10 726 0 785 -1 817 -18z m-1675 -608 l466 -435 0 -710 0
   -709 -215 0 -215 0 0 413 c0 410 0 412 -24 462 -25 56 -78 107 -133 130 -52
   22 -654 22 -706 0 -55 -23 -108 -74 -133 -130 -24 -50 -24 -52 -24 -462 l0
   -413 -215 0 -215 0 0 709 0 710 466 435 c256 240 470 436 474 436 5 0 218
   -196 474 -436z m-1801 -174 c-11 -55 21 -112 112 -199 47 -45 89 -81 95 -81 7
   0 10 -229 10 -700 l0 -700 -526 0 -526 0 -29 29 -29 29 0 826 0 826 450 0 450
   0 -7 -30z m3547 -796 l0 -826 -29 -29 -29 -29 -526 0 -526 0 0 700 c0 459 3
   700 10 700 16 0 157 138 181 177 12 19 23 55 25 81 2 26 3 48 4 50 0 1 200 2
   445 2 l445 0 0 -826z m-2310 -459 l0 -425 -125 0 -125 0 0 400 0 401 25 24
   c22 23 31 25 125 25 l100 0 0 -425z m405 400 l25 -24 0 -401 0 -400 -125 0
   -125 0 0 425 0 425 100 0 c94 0 103 -2 125 -25z"
      />
      <path
        d="M2325 4277 c-83 -71 22 -194 109 -126 20 16 26 29 26 59 0 48 -25 79
   -71 86 -28 5 -41 1 -64 -19z"
      />
      <path
        d="M2015 4259 c-32 -19 -45 -41 -45 -79 0 -61 62 -98 125 -74 25 10 47
   62 40 94 -11 52 -76 84 -120 59z"
      />
      <path
        d="M2564 4056 c-58 -49 -20 -146 57 -146 43 0 79 39 79 85 0 74 -80 110
   -136 61z"
      />
      <path
        d="M2159 3895 c-29 -16 -52 -66 -42 -93 30 -85 141 -82 167 5 9 30 -19
   81 -50 93 -33 13 -44 12 -75 -5z"
      />
      <path
        d="M2505 3735 c-56 -55 -21 -145 55 -145 55 0 85 39 81 103 -2 30 -47
   67 -81 67 -19 0 -40 -9 -55 -25z"
      />
      <path
        d="M2330 1953 c-36 -14 -72 -48 -91 -85 -19 -36 -20 -55 -17 -217 3
   -177 3 -178 31 -214 49 -65 60 -67 307 -67 247 0 258 2 307 67 28 36 28 37 31
   214 3 162 2 181 -17 217 -11 22 -35 51 -53 64 -32 22 -40 23 -258 25 -124 1
   -232 -1 -240 -4z m400 -288 l0 -125 -170 0 -170 0 0 125 0 125 170 0 170 0 0
   -125z"
      />
      <path
        d="M720 1699 c-41 -12 -94 -60 -110 -99 -7 -18 -10 -89 -8 -206 3 -170
   4 -181 27 -213 43 -60 84 -71 271 -71 153 0 168 2 205 23 22 12 50 38 62 56
   22 32 23 43 23 213 0 206 -7 232 -73 276 -39 26 -46 27 -201 29 -89 1 -177 -3
   -196 -8z m300 -289 l0 -130 -125 0 -125 0 0 130 0 130 125 0 125 0 0 -130z"
      />
      <path
        d="M692 919 c-28 -14 -51 -36 -67 -64 -24 -40 -25 -49 -25 -215 0 -166
   1 -175 25 -216 42 -72 81 -84 271 -84 181 0 222 12 265 71 23 33 24 39 24 229
   0 190 -1 196 -24 229 -43 59 -84 71 -266 71 -143 0 -165 -2 -203 -21z m328
   -279 l0 -130 -125 0 -125 0 0 130 0 130 125 0 125 0 0 -130z"
      />
      <path
        d="M4048 1700 c-43 -13 -84 -47 -102 -84 -13 -27 -16 -68 -16 -211 0
   -197 4 -214 67 -262 36 -28 38 -28 206 -31 197 -4 239 6 285 66 27 35 27 37
   30 215 2 123 0 189 -9 208 -16 40 -71 86 -116 98 -44 13 -305 13 -345 1z m302
   -290 l0 -130 -125 0 -125 0 0 130 0 130 125 0 125 0 0 -130z"
      />
      <path
        d="M4024 921 c-23 -10 -52 -34 -65 -52 -23 -33 -24 -39 -24 -229 0 -190
   1 -196 24 -229 43 -59 84 -71 265 -71 190 0 229 12 271 84 24 41 25 50 25 216
   0 166 -1 175 -25 216 -42 72 -81 84 -271 84 -133 0 -166 -3 -200 -19z m326
   -281 l0 -130 -125 0 -125 0 0 130 0 130 125 0 125 0 0 -130z"
      />
    </g>
  </svg>
);

const ClubHouseIcon = (props) => <Icon component={ClubHouseSvg} {...props} />;

export default ClubHouseIcon;
